<template>
   <b-container>
       <b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link>
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row>
		<b-row >
             <b-col class="text-left">
			<h3>Add Comment </h3><hr>
        </b-col>
		</b-row> 
<b-row style='border: 1px solid black;border-radius: 5px; padding: 5px;margin: 5px;'><b-col>
  <b-form action="insertTicketComment" id="addCommentAction" method="get" v-on:submit.prevent>
				<div style="text-align: left" auto>
					<b>Ticket Nr :</b> <span id="idTicket">{{idTicket}}</span><br>
           <input type="hidden" name="idTicket" :value="idTicket"/>
					<b>Ticket Created :</b> {{TicketIssued}}<br>
					<b>Assigned as job to  :</b> {{EmpUserE}}<br>
					<b>Created By :</b> {{LoggerUserE}}<br>
					<b>Site :</b> {{SiteName}}<br>
					<b>At Fault :</b> <span id="atFault" name="atFault" v-bind:data-atfault="Reason">{{ReasonText}}</span><br>
					
					<b>Affected Meters :</b><br>
				
          <div v-for="meterAccount in meterAccounts" v-bind:key="meterAccount.idMeterAccount"> 
          <span> 
						{{meterAccount.MeterAccountName}}
          </span>  
            <br>
          </div>
					
					<b>Original Description</b><br>
					{{Description}}<br>
			<!--
					<div v-if="hasComments">
						<b>Comments :</b><br>
          </div>
					<div v-else>
						<b>No Comments</b><br>
					</div>
						
					<div id="ticketcomments" >
             <div v-for="(comment, index)  in cmntHistory" >
					
						{{comment.Comment}}<br>
						<small><b>Added by {{comment.CreatedBy}} on {{comment.CreatedDate}} </b></small><br>
            <component-tagview :ticketid="idTicket" :idticketcomment="comment.idTicketHistory" :showadd="false"></component-tagview>
						<br>
					
            </div>-->
                    <div v-if="(cmntHistory)&& (cmntHistory.length >  0)">
                    
                    <b-link v-b-toggle="'comment'+ idTicket" >{{cmntHistory.length}} Comments (Click to show)</b-link> <br>
                    </div>
                    <div v-else>
                        <b>No Comments. </b><br>
                    </div>
                    <b-collapse :id="'comment' + idTicket" class="collapse">
                        Comment History :<br><br>
                        <div v-for="comment  in cmntHistory" v-bind:key="comment.idComment">
                            <b>Comment Added by {{comment.CreatedBy}} on {{comment.CreatedDate}} </b><br>
                            {{comment.Comment}}<br>
                            <component-tagview :ticketid="idTicket" :idticketcomment="comment.idTicketHistory" :showadd="false"></component-tagview><br>
                            
                        </div>
                    </b-collapse> 
					</div>

					<b>New Comment</b><textarea v-model="comment"   name="comment" id="id_Comment" rows="4" class="form-control" ></textarea ><br>
					
					<b>Reason for bypass if applicable</b>		
							<select class="form-control" id="id_Reason" name="Reason" style="overflow:scroll;" >
                  <option v-for="reason in reasonsBypass" v-bind:key="reason.idTicketReason" :value="reason.idTicketReason">{{reason.Name}} </option>
							</select>
					<br>
					<b>Supplies if applicable</b>		
							<input type="text" name="supplies" id="id_Supplies"  maxlength="500" class="form-control" v-model="supplies"/>
					<br> 
                    <!--<b>Add Ticket Tags to this comment <a href="#" target="_self" @click="showAddTagSection = !showAddTagSection">(Optional click to show [+])</a></b><hr>
                    <div v-if="showAddTagSection" style="border-style: solid;border-width:1px; border-radius: 4px;padding:5px">
					<component-createtag></component-createtag>
                    </div><br>-->

					<button  type="button" name="addComent" class="btn btn-primary addComent"  id="addComment" style="width:100%;" @click.once="submit">Add Comment</button><br><br>
					<button  type="button" name="Cancel" id="cancelbtn" class="btn btn-primary" style="width:100%;" @click="$router.go(-1)">Cancel</button>
					
              
			</b-form>


   
  

</b-col></b-row>
   </b-container>
</template>



<script type="text/javascript">
//const ActionButton = require('./ActionButton.vue');
import addTicketTag from '../components/TagView.vue'
import createTicketTag from '../components/createTicketTag.vue'
import axios from 'axios';
//import moment from 'moment';


//module.exports = {
  export default {
    props: ['idTicket','url'], 
    components: {
    'component-tagview' : addTicketTag,
    'component-createtag' : createTicketTag,
    
  },
  data: () => ({
    TicketIssued : null,
    EmpUserE : null,
    LoggerUserE : null,
    SiteName : null,
    showAddTagSection : false,
    Reason :null,
    ReasonText : null,
    meterAccounts : null,
    Description : null,
    cmntHistory : null,
    hasComments : true,
    comment : "",
    supplies : "",
    reasonsBypass : null,
    employee : "",
    addedTags : null,
    submitobject : null
    
    
    
  }),
  methods: {
      submit : function() {
        console.log("Submit");
        let mainObject = this;
        let validObject = true;
        var submitobject = new Object;
        submitobject.idTicket = this.idTicket;
        submitobject.Reason = this.Reason;
        submitobject.supplies = this.supplies;
        submitobject.comment = this.comment;
        submitobject.addedTags = this.addedTags;
        submitobject.employee =  localStorage.getItem('employee');
        submitobject.logger = localStorage.getItem('employee');


        switch ( true )
        {
            case  ( (submitobject.comment == null)||( submitobject.comment.length < 1 ))  : 
                validObject = false;
                mainObject.showAlert("Please add a comment.",2000,false);
                break;
            
        
            default : validObject = true;
        }
        if ( validObject )
        {
            //var objectMain = this;
            console.log(submitobject);
            mainObject.$swal({
                title: 'Are you sure you want to add this comment?',
                text: submitobject.comment,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Add Comment'
                }).then((result) => {
                if (result.value) {
                    console.log("Selected True");


                    axios.post(localStorage.getItem('ticketCopURL') +'/insertTicketComment', {
                        idEmployee : mainObject.idEmployee,
                        idTicket : submitobject.idTicket,
                        comment : submitobject.comment,
                        supplies: submitobject.supplies,
                        Reason : submitobject.Reason,   
                        employee : mainObject.employee,
                        addedTags : submitobject.addedTags ,
                        createNewComment : true
                        },
                        {
                            headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                            
                   // submitobject//,
                    //employee : localStorage.getItem('employee')
                    
                })
                .then(function (response) {
                    console.log(response.data);
                    if ( response.data.status == "Success" )
                    {
                        let timerInterval
                        mainObject.$swal({
                        //title: 'Auto close alert!',
                        html: 'Comment was succesfully added.',
                        timer: 2000,
                        onBeforeOpen: () => {
                            mainObject.$swal.showLoading()
                            timerInterval = setInterval(() => {
                            mainObject.$swal.getContent().querySelector('strong')
                                
                            }, 100)
                        },
                        onClose: () => {
                            clearInterval(timerInterval)
                        }
                        }).then((result) => {
                        if (
                            // Read more about handling dismissals
                            result.dismiss === mainObject.$swal.DismissReason.timer
                        ) {
                            console.log('I was closed by the timer');
                            mainObject.$router.go(-1);
                        }
                        })  
                    
                    }
                    else
                    {
                        let timerInterval
                        mainObject.$swal({
                        //title: 'Auto close alert!',
                        html: 'Error could not add comment.',
                        timer: 2000,
                        onBeforeOpen: () => {
                            mainObject.$swal.showLoading()
                            timerInterval = setInterval(() => {
                            mainObject.$swal.getContent().querySelector('strong')
                            
                            }, 100)
                        },
                        onClose: () => {
                            clearInterval(timerInterval)
                        }
                        }).then((result) => {
                        if (
                            // Read more about handling dismissals
                            result.dismiss === mainObject.$swal.DismissReason.timer
                        ) {
                            //console.log('I was closed by the timer');
                            //mainObject.$router.go(-1);
                        }
                        }) 
                    

                    }
                    
                })
                .catch(function (error) {
                    console.log(error);
                        let timerInterval
                        mainObject.$swal({
                        //title: 'Auto close alert!',
                        html: 'Error could not add comment.',
                        timer: 1000,
                        onBeforeOpen: () => {
                            mainObject.$swal.showLoading()
                            timerInterval = setInterval(() => {
                            mainObject.$swal.getContent().querySelector('strong')
                                
                            }, 100)
                        },
                        onClose: () => {
                            clearInterval(timerInterval)
                        }
                        }).then((result) => {
                        if (
                            // Read more about handling dismissals
                            result.dismiss === mainObject.$swal.DismissReason.timer
                        ) {
                            //console.log('I was closed by the timer');
                            //mainObject.$router.go(-1);
                        }
                        }) 
                })
                .then(function () {
                    // always executed
                    console.log("Inserted Ticket Comment ");
                });
                
                }
                else
                {
                    console.log("Selected false");
                }
            })
        }
        



      },
      showAlert : function (msg,delay,gotoprevPage)
      {
        let timerInterval;
        let mainObject = this;
        mainObject.$swal({
        //title: 'Auto close alert!',
        html: msg,
        timer: delay,
        onBeforeOpen: () => {
            mainObject.$swal.showLoading()
            timerInterval = setInterval(() => {
            mainObject.$swal.getContent().querySelector('strong')
                
            }, 100)
        },
        onClose: () => {
            clearInterval(timerInterval)
        }
        }).then((result) => {
        if (
            // Read more about handling dismissals
            result.dismiss === mainObject.$swal.DismissReason.timer
        ) {
            if ( gotoprevPage )
            mainObject.$router.go(-1);
        }
        })  
      }
      
      
  },
  
  created: function () {
     this.idTicket = this.$route.params.idTicket;
     console.log("createComment created");
     console.log(this.idTicket);
    this.employee =  localStorage.getItem('employee');
    var objectMain = this;
    

    axios.get(localStorage.getItem('ticketCopURL') +'/getTicketInfo', {
          params: {
            idTicket : objectMain.idTicket
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log(response.data);
          objectMain.cmntHistory = response.data.cmntHistory
          objectMain.meterAccounts = response.data.meterAcs
          objectMain.SiteName = response.data.site.SiteName
          objectMain.Reason = response.data.ticket.Reason
          objectMain.ReasonText = response.data.ticket.Name[0]
          objectMain.TicketIssued = response.data.ticket.TicketIssued
          objectMain.EmpUserE = response.data.ticket.EmpUserE
          objectMain.LoggerUserE = response.data.ticket.LoggerUserE
          objectMain.Description = response.data.ticket.Description[0]
          //objectMain.supplies = response.data.ticket.Supplies
          if ( objectMain.cmntHistory.length > 0 ) 
            objectMain.hasComments = true
          else
             objectMain.hasComments = false



          

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          console.log("Made request to get ticket info for idTicket ");
          console.log(objectMain);
    });


    axios.get(localStorage.getItem('ticketCopURL') +'/getReasonTicket', {
          params: {
           
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log(response.data);
          objectMain.reasonsBypass = response.data
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          console.log("Made request to get ticket Reasons");
    }); // end of axios call
  }
  
  /*,
  components: {
    ActionButton
  }*/
};
</script>



